// extracted by mini-css-extract-plugin
export var header = "_u2-1";
export var maskBottom = "_u2-6";
export var maskMiddle = "_u2-7";
export var maskTop = "_u2-5";
export var root = "_u2-0";
export var scrollDownButton = "_u2-3";
export var scrollDownButtonHidden = "_u2-4";
export var viewport = "_u2-2";